import { createSlice } from "@reduxjs/toolkit";

export const salesChannelsSlice = createSlice({
  name: 'salesChannels',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startSalesChannels: (state) => { state.isLoading = true },
    setSalesChannels: (state, { payload: { data, error }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startSalesChannels, setSalesChannels } = salesChannelsSlice.actions;

export  default salesChannelsSlice;
